import React, { useState } from "react";
import styles from "./EMIDetails.module.scss";
import { IoIosArrowDown } from "react-icons/io";

export default function EMIDetails(props) {
  const { emiData } = props;

  const [visibleItems, setVisibleItems] = useState(new Array(emiData?.length).fill(false));

  const toogleItems = (index) => {
    const updatedVisibility = [...visibleItems];
    updatedVisibility[index] = !updatedVisibility[index];
    setVisibleItems(updatedVisibility);
  };

  return (
    <div>
      <div className={styles.emiBreakdown}>
        <div className={styles.title}>
          <div>EMI Dates</div>
          <div>Amount</div>
        </div>

        {emiData.map((item, index) => (
          <div className={styles.emiContainer} key={index} onClick={() => toogleItems(index)}>
            <div className={styles.lists}>
              <div className={styles.info}>
                <div className={styles.number}>{index + 1}</div>
                <div className={styles.date}>
                  {new Date(item.dueDate).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </div>
              </div>
              <div className={styles.price}>
                <span>₹ {item?.emi.toLocaleString("en-IN")}</span>
                <IoIosArrowDown size={15} color="#9c9c9c" />
              </div>
            </div>

            {visibleItems[index] && (
              <React.Fragment>
                <div className={styles.summary}>
                  <div>Principal</div>
                  <div>₹{item?.principal.toLocaleString("en-IN")}</div>
                </div>
                <div className={styles.summary}>
                  <div>Interest</div>
                  <div>₹{item?.interest.toLocaleString("en-IN")}</div>
                </div>

                {/* <div className={styles.summary}>
                  <div>GST</div>
                  <div>₹0</div>
                </div>
                <div className={styles.summary}>
                  <div>Amount Paid</div>
                  <div>₹0</div>
                </div>
                <div className={styles.summary}>
                  <div>Balance Amount</div>
                  <div>₹0</div>
                </div> */}
              </React.Fragment>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
